import { z } from 'zod';

export const schemaConsorsRealEstate = z
    .number()
    .min(0)
    .max(999999)
    .refine((val) => /[0-9]{1,13}(\.[0-9]*)?/.test(val.toString()), {
        message: 'Invalid characters',
    });
